import { useContext, useRef, useState } from "react";
import EstablishedContacts from "./EstablishedContacts";
import Notifications from "../CommonComponents/Notifications/Notifications";
import "./Messenger.scss";
import PrsInfo from "./PrsInfo";
import { useEstablishedContacts } from "./effects";
import MessagesWidget from "./MessagesWidget";
import ContactAddDialog from "./ContactAddDialog";
import { AppContext } from "../Context/AppContext";
import ThemeControl from "../CommonComponents/ThemeControl/ThemeControl";
import PencilIcon from "../Icons/Pencil";
import EyeIcon from "../Icons/Eye";
import BackButton from "../CommonComponents/BackButton/BackButton";
import { MessagesContext } from "../Context/MessagesContext";
import AlertWindow from "./AlertWindow/AlertWindow";
import TemplateWindow from "./TemplateWindow/TemplateWindow";
import TemplatesList from "./TemplatesList";
function Messenger() {
	const [info, setInfo] = useState();
	const [isAdmin, setIsAdmin] = useState(false);
	const [establishedContacts, updateEstablishedContacts] =
		useEstablishedContacts();
	const [activeContact, setActiveContact] = useState(null);
	const [addDialogOpen, setAddDialogOpen] = useState(false);
	const [alertWindowOpen, setAlertWindowOpen] = useState(false);
	const [templateWindowOpen, setTemplateWindowOpen] = useState(false);
	const [currentTemplateInfo, setCurrentTemplateInfo] = useState({
		id: null,
		name: null,
	});
	const inputRef = useRef();
	//contexts
	const { theme } = useContext(AppContext);
	const { setInputBoxVisible, setSendDataFlag } = useContext(MessagesContext);
	const maxFont = Math.max(
		+theme.headerFontMultiplier,
		+theme.bodyLeftFontMultiplier,
		+theme.bodyCenterFontMultiplier,
		+theme.bodyRightFontMultiplier,
		+theme.footerFontMultiplier
	);
	return (
		<div
			className='messenger-main'
			color={theme.color}
			style={{
				fontSize: `${(16 / theme.scaleFactor) * maxFont}px`,
			}}
		>
			<div
				className='header'
				style={{
					fontSize: `${
						(16 / theme.scaleFactor) * theme.headerFontMultiplier
					}px`,
				}}
			>
				<BackButton />
				<PrsInfo />
				<div className='support-header'>
					<ThemeControl />
					<PencilIcon
						width={2}
						height={2}
						func={() => setIsAdmin(true)}
						className={`admin-toggle ${isAdmin ? "admin-toggle-active" : ""}`}
					/>
					<EyeIcon
						width={3}
						height={3}
						func={() => setIsAdmin(false)}
						className={`eye-toggle ${!isAdmin ? "eye-toggle-active" : ""}`}
					/>
					{isAdmin ? (
						<>
							<button
								className='add-contact'
								onClick={() => setAddDialogOpen(true)}
							>
								Добавить контакт
							</button>
							<button
								onClick={() => {
									Notification.requestPermission(function (permission) {});
								}}
							>
								{`${
									Notification.permission === "default"
										? "Вкл. уведомления"
										: "Увед. активны"
								}`}
							</button>
						</>
					) : null}
				</div>
			</div>

			<div
				className='contact-established'
				style={{
					fontSize: `${
						(16 / theme.scaleFactor) * theme.bodyLeftFontMultiplier
					}px`,
				}}
			>
				<EstablishedContacts
					contacts={establishedContacts}
					updateContacts={updateEstablishedContacts}
					setActiveContact={setActiveContact}
					activeContact={activeContact}
					inputRef={inputRef}
					setAlertWindowOpen={setAlertWindowOpen}
				/>
			</div>
			<div
				className='message-area'
				style={{
					fontSize: `${
						(16 / theme.scaleFactor) * theme.bodyCenterFontMultiplier
					}px`,
				}}
			>
				<MessagesWidget
					activeContact={activeContact}
					inputRef={inputRef}
					setInputBoxVisible={setInputBoxVisible}
					setActiveContact={setActiveContact}
				/>
			</div>
			<Notifications info={info} setInfo={setInfo} />
			{addDialogOpen ? (
				<ContactAddDialog
					setAddDialogOpen={setAddDialogOpen}
					setInfo={setInfo}
					updateEstablishedContacts={updateEstablishedContacts}
					establishedContacts={establishedContacts}
				/>
			) : null}
			{alertWindowOpen ? (
				<AlertWindow
					setAlertWindowOpen={setAlertWindowOpen}
					inputRef={inputRef}
					setActiveContact={setActiveContact}
				/>
			) : null}
			<div
				className={`toolbox ${
					activeContact === null ? "toolbox-disabled" : ""
				}`}
				style={{
					fontSize: `${
						(16 / theme.scaleFactor) * theme.bodyRightFontMultiplier
					}px`,
				}}
			>
				<button onClick={() => setInputBoxVisible((prev) => !prev)}>
					Сообщение
				</button>
				<button
					onClick={() => {
						setSendDataFlag(true);
					}}
				>
					Отправить
				</button>
				<div>
					<div>Шаблоны</div>
					<div>
						<TemplatesList
							setCurrentTemplateInfo={setCurrentTemplateInfo}
							setTemplateWindowOpen={setTemplateWindowOpen}
						/>
					</div>
				</div>
			</div>
			<div className='burger-icon'>burger</div>
			{templateWindowOpen ? (
				<TemplateWindow
					currentTemplateInfo={currentTemplateInfo}
					setTemplateWindowOpen={setTemplateWindowOpen}
					activeContact={activeContact}
					setInfo={setInfo}
				/>
			) : null}
		</div>
	);
}

export default Messenger;
